import { Injectable } from '@angular/core';
import { fromEvent, Subject, Subscription, timer } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services/authentication.service';
import { EmittersService } from './emitters.service';

@Injectable({
	providedIn: 'root'
})
export class InactivityService {
	private _timerSubscription!: Subscription;
	private _timerDuration = environment.timerDuration;

	private _timeoutCallback = new Subject<void>();

	_clickSubscription!: Subscription;
	_keyPressSubscription!: Subscription;
	_timeoutSubscription!: Subscription;

	constructor(private _emittersService: EmittersService, private _authenticationService: AuthenticationService) {
		_emittersService.inactivityRestartCount.subscribe(() => this._init());
		this._init();
	}

	private _init(): void {
		this._resetTimer();
		this._clickSubscription = this._listenToClicks().subscribe((event: Event) => {
			this._resetTimer();
		});

		this._keyPressSubscription = this._listenToKeyPress().subscribe((event: KeyboardEvent) => {
			this._resetTimer();
		});

		this._timeoutSubscription = this._onTimeout().subscribe(() => {
			if (this._authenticationService.currentUser) this._executeAfterTimeout();
		});
	}

	private _onTimeout(): any {
		return this._timeoutCallback.asObservable();
	}

	private _resetTimer(): any {
		if (this._timerSubscription) this._timerSubscription.unsubscribe();
		this._timerSubscription = timer(this._timerDuration).subscribe(() => {
			this._timeoutCallback.next();
		});
	}

	private _listenToClicks(): any {
		return fromEvent(document, 'click');
	}

	private _listenToKeyPress(): any {
		return fromEvent(document, 'keydown');
	}

	private _executeAfterTimeout(): any {
		this._clickSubscription.unsubscribe();
		this._keyPressSubscription.unsubscribe();
		const inactivity = document.getElementById('inactivity');
		inactivity?.click();
		this._emittersService.inactivityStartCount.emit();
	}
}
